'use client'

import { colorsPrimaryNames } from '@/constants/constants'
import { LearningPedagogySectionProps } from '@/widgets/landing-page-widgets/LearningPedagogySection/schema'
import { Typography } from '@pw-tech/omni-ui'
import Image from 'next/image'
import './container.css'
import styles from './learningPedagogy.module.css'

const LearningPedagogySection = ({
  learningPedagogyData,
}: {
  learningPedagogyData: LearningPedagogySectionProps
}) => {
  return (
  <div className="mx-auto max-w-6xl px-4 w-full md:px-6">
  <div className="py-6 md:py-14 flex flex-col gap-6 md:gap-12">
  <div className="flex flex-col gap-1">
          <Typography variant='heading2' weight='bold' className="text-center" color='#1b2124'>
            {learningPedagogyData.heading}
          </Typography>
          <Typography variant='heading4' className="text-center" color='#757575'>
            {learningPedagogyData.subHeading}
          </Typography>
        </div>

  <div className="flex flex-row gap-4 md:gap-8 overflow-x-auto">
          {learningPedagogyData.cards.map(({ title, description, image }, ind: number) => {
            const bgColorPrimaryName = colorsPrimaryNames[ind % colorsPrimaryNames.length]
            const bgColorVar = `--${bgColorPrimaryName}-color`
            return (
              <div
                key={title}
                className='min-w-[264px] h-[312px] md:min-w-[340px] md:h-[402px] rounded-3xl group overflow-hidden'
                style={{ background: `var(${bgColorVar}-50)` }}
              >
                <div className="flex flex-col items-center justify-center p-4 md:p-8 gap-2 md:gap-4">
                  <Typography
                    variant='heading4'
                    className="text-center"
                    style={{ color: `var(${bgColorVar}-800)` }}
                    weight='bold'
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant='subHeading'
                    className="text-center"
                    style={{ color: `var(${bgColorVar}-800)` }}
                  >
                    {description}
                  </Typography>
                </div>
                <div className='relative flex justify-center items-center origin-[top_center] group-hover:scale-[1.25] transition-transform duration-300'>
                  <Image src={image} width={320} height={241} alt='banner-image' loading='lazy' />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default LearningPedagogySection
